import React from 'react';
import { Card, Stack } from '@mantine/core';

import dt from '~/testing';

import useStyles from '~/domains/common/components/AlertCard/alertCard.styles';

import ContestNotificationCardContestInfo from './ContestNotificationCardContestInfo';
import type { ContestNotificationCardProps } from './types';

function ContestNotificationCard({ notification, onClick }: ContestNotificationCardProps) {
  const { classes } = useStyles();

  return (
    <Card
      className={classes.container}
      p="md"
      radius="lg"
      shadow="sm"
      data-test-id={dt.contest.common.contestNotificationCard}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <Stack /* eslint-disable-line local-rules/use-theme-tokens */ spacing={12}>
        <ContestNotificationCardContestInfo notification={notification} />
      </Stack>
    </Card>
  );
}

export default ContestNotificationCard;
